import { Outlet } from 'react-router-dom'

const Helpdesk = () => {
  return (
    <><Outlet /></>
  )
}

export default Helpdesk